import React from 'react';

/**
 * Checks whether a click event includes modifier keys (Ctrl, Cmd, Shift, Alt)
 * or non-primary mouse buttons (middle-click), which browsers use to open links in new tabs/windows.
 */
export const isModifiedClick = (e: React.MouseEvent): boolean => {
  return Boolean(e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0);
};

/**
 * Maps an internal tab ID or sub-route to its canonical URL path.
 */
export const getTabHref = (tabId: string): string => {
  if (tabId === 'landing') return '/';
  if (tabId === 'grading-settings' || tabId === 'tetapan-grading') return '/grading/settings';
  if (tabId === 'grading-leaderboard' || tabId === 'leaderboard') return '/grading/leaderboard';
  if (tabId === 'ujian-bertulis') return '/ujian-bertulis';
  if (tabId === 'pengurusan-silibus' || tabId === 'syllabus-manage' || tabId === 'kurikulum') return '/pengurusan-silibus';
  if (tabId === 'settings') return '/settings/alert';
  if (tabId === 'ujian' || tabId === 'ujian-bengkung') return '/ujian-bengkung';
  if (tabId === 'seller' || tabId === 'inventory') return '/seller/orders';
  if (tabId === 'donasi') return '/donasi';
  if (tabId === 'donations') return '/donations';
  return `/${tabId}`;
};

